/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_Body1Inputs */

const en_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To bring the power of focus to more people, Forest has entered a new phase.`)
};

const ar_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من أجل إيصال قوة التركيز إلى عدد أكبر من الناس، دخلت Forest مرحلة جديدة.`)
};

const de_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um mehr Menschen von der Kraft des Fokus zu überzeugen, hat Forest eine neue Phase eingeleitet.`)
};

const es_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para llevar el poder de la concentración a más personas, Forest ha entrado en una nueva fase.`)
};

const fr_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour offrir le pouvoir du focus au plus grand nombre, Forest entre dans une nouvelle ère.`)
};

const it_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per portare il potere della concentrazione a più persone, Forest è entrata in una nuova fase.`)
};

const ja_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`より多くの人に集中の力を届けるため、Forestは新たなステージへ進みました。`)
};

const ko_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 분들에게 집중의 힘을 제공하기 위해 Forest가 새로운 단계에 들어섰어요.`)
};

const pt_br_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para levar o poder do foco para mais pessoas, o Forest entrou em uma nova fase.`)
};

const ru_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest вступает в новую фазу, чтобы помочь большему числу людей сосредоточиться.`)
};

const th_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพื่อส่งต่อพลังแห่งการโฟกัสให้กับผู้คนมากยิ่งขึ้น Forest ได้ก้าวเข้าสู่ช่วงใหม่แล้ว`)
};

const tr_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanın gücünü daha fazla insana ulaştırmak için Forest yeni bir aşamaya geçti.`)
};

const zh_cn_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为了让专注的力量带给更多人，
Forest 迈向了新的阶段`)
};

const zh_tw_pro_user_appreciation_letter_commitment_body1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為了讓專注的力量帶給更多人，
Forest 邁向了新的階段`)
};

/**
* | output |
* | --- |
* | "To bring the power of focus to more people, Forest has entered a new phase." |
*
* @param {Pro_User_Appreciation_Letter_Commitment_Body1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_body1 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_Body1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_Body1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_body1(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_body1(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_body1(inputs)
});